export default __webpack_public_path__ + "static/media/pencho.67e5e41f.jpeg";